// Helper condiviso: salva una risposta axios (responseType:"blob") usando il filename
// e il MIME REALI inviati dal server (Content-Disposition + Content-Type), non valori dal browser.
export const filenameFromDisposition = (cd, fallback) => {
  if (cd) {
    // Preferisci RFC 5987: filename*=UTF-8''<percent-encoded>
    const star = cd.match(/filename\*=UTF-8''([^;]+)/i);
    if (star) {
      try { return decodeURIComponent(star[1].trim()); } catch { /* ignore */ }
    }
    const plain = cd.match(/filename="?([^";]+)"?/i);
    if (plain) return plain[1].trim();
  }
  return fallback;
};

export const saveBlobResponse = (res, fallbackName, { inline = false } = {}) => {
  const cd = (res && res.headers && res.headers["content-disposition"]) || "";
  const type = (res && res.headers && res.headers["content-type"]) || "application/octet-stream";
  const filename = filenameFromDisposition(cd, fallbackName);
  // Blob col MIME reale del server: evita che il browser reinterpreti il binario come testo
  const blob = new Blob([res.data], { type });
  const url = URL.createObjectURL(blob);
  if (inline) {
    window.open(url, "_blank");
  } else {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  setTimeout(() => URL.revokeObjectURL(url), 30000);
  return { filename, type };
};
